const AgeVerificationOverlay = ({ onConfirm }) => {
    const handleLeave = () => {
        window.location.href = "https://www.google.com";
    };

    return (
        <div className="fixed inset-0 z-[9999] bg-black/90 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg max-w-md w-full p-6 text-center shadow-xl">
                <h1 className="text-xl font-bold text-gray-900 mb-4">
                    Ai împlinit vârsta de 18 ani?
                </h1>
                <p className="text-sm text-gray-600 mb-6">
                    LATG este o platformă de analize și informații statistice sportive. Pe acest
                    site nu se pot plasa pariuri, depune fonduri sau încasa câștiguri. Predicțiile
                    au caracter informativ și nu garantează rezultate. Jocurile de noroc implică
                    riscuri financiare.
                </p>
                <div className="flex flex-col gap-3">
                    <button
                        onClick={onConfirm}
                        className="w-full bg-[#2c3e50] text-white font-semibold py-3 rounded-md hover:bg-[#1a252f] transition-colors"
                    >
                        Confirm că am minimum 18 ani
                    </button>
                    <button
                        onClick={handleLeave}
                        className="w-full bg-gray-100 text-gray-700 font-semibold py-3 rounded-md hover:bg-gray-200 transition-colors"
                    >
                        Nu am 18 ani – părăsesc site-ul
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AgeVerificationOverlay;
